module.exports = __webpack_public_path__ + "img/partnership.42651ee3.jpg";